import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {

  @ViewChild('reportSummaryTable', { static: true })
  public reportSummaryTable: Table;

  public reportSummaryTableData: any = [];
  public userID: any;

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService
  ) { }

  ngOnInit(): void {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.dashboardSummaryReport();
  }

  dashboardSummaryReport(){
    this.loader.start();
    this.deptDashBoardService
      .dashboardSummaryReport()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Application Abstract Report', '', new Date(), 'Success');
          this.reportSummaryTableData = res;
          console.log("reportSummaryTableData", this.reportSummaryTableData);
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Application Abstract Report', '', new Date(), err);
          console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

}
